import { useState, useEffect, useCallback } from "react";

export type PageOrientation = 'portrait' | 'landscape';

export default function usePageOrientation(): PageOrientation {
  const [orientation, setOrientation] = useState<PageOrientation>('landscape');

  const onOrientationChange = useCallback((event: MediaQueryListEvent | MediaQueryList) => {
    if (event.matches) {
      setOrientation('portrait');
    } else {
      setOrientation('landscape');
    }
  }, []);

  useEffect(function setInitialOrientation() {
    if (typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const matchOrientation = window.matchMedia("(orientation: portrait)");

    onOrientationChange(matchOrientation);

    matchOrientation.addEventListener(
      'change', onOrientationChange
    );

    return () => {
      matchOrientation.removeEventListener('change', onOrientationChange);
    };
  }, [setOrientation, onOrientationChange]);

  return orientation;
}
